export const getMockUsers = () => {
  return [
    {
      id: 1,
      userId: "9876543210",
      createdDate: new Date().toISOString(),
      data: {
        name: "Vamshi",
        score: 3,
        result: "Low",
      },
    },
    {
      id: 2,
      userId: "9123456780",
      createdDate: new Date().toISOString(),
      data: {
        name: "Rahul",
        score: 6,
        result: "Medium",
      },
    },
    {
      id: 3,
      userId: "9988776655",
      createdDate: new Date().toISOString(),
      data: {
        name: "Anjali",
        score: 9,
        result: "High",
      },
    },
  ];
};